import { Button, Grid, Group, Image, Text, TextInput } from '@mantine/core';
import { IconDeviceFloppy, IconTrash } from '@tabler/icons-react';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import FileUpload from '../FileUpload';
import ConfirmationModal from '../Modals/ConfirmationModal';

const AssetForm = ({ asset: passedAsset, deleteAsset, saveAsset, closeModal, tab }) => {
  const [asset, setAsset] = useState(passedAsset);
  const [file, setFile] = useState();
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const navigate = useNavigate();

  const isImageAsset = tab === 'images';

  const handleChange = (key, value) => {
    setAsset({ ...asset, [key]: value });
  };

  if (!asset) {
    return '';
  }

  let deleteButton = '';
  if (deleteAsset) {
    deleteButton = (
      <Button color="red" onClick={() => setConfirmDeleteOpen(true)}>
        <IconTrash size={14} /> Delete
      </Button>
    );
  }

  let assetVisual;
  if (asset.url) {
    assetVisual = (
      <Image style={{ width: '100%', height: 'auto' }} src={asset.url} alt={asset.title} title={asset.title} />
    );
  } else {
    assetVisual = (
      <div>
        <FileUpload
          onFileSet={(files) => {
            setFile(files[0]);
          }}
        />
        {isImageAsset ? (
          <Text size="sm" c="dimmed">
            We accept only "png" and "jpg" files
          </Text>
        ) : (
          <Text size="sm" c="dimmed">
            We accept "PDF", "Excel", "Word" and regular text files
          </Text>
        )}
      </div>
    );
  }

  return (
    <>
      <Grid mb="md">
        <Grid.Col span={{ base: 12, sm: 2 }}>
          <Text size="sm" fw={500}>
            Name
          </Text>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 10 }}>
          <TextInput
            name="title"
            type="text"
            value={asset.title}
            placeholder="e.g. Check This Out!"
            onChange={(e) => handleChange(e.target.name, e.target.value)}
          />
        </Grid.Col>
      </Grid>
      <Grid mb="md">
        <Grid.Col span={{ base: 12, sm: 2 }}>
          <Text size="sm" fw={500}>
            Description
          </Text>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 10 }}>
          <TextInput
            name="description"
            type="text"
            value={asset.description}
            placeholder="e.g. Check This Out!"
            onChange={(e) => handleChange(e.target.name, e.target.value)}
          />
        </Grid.Col>
      </Grid>
      <Grid mb="md">
        <Grid.Col span={{ base: 12, sm: 2 }}>
          <Text size="sm" fw={500}>
            {isImageAsset ? 'Image' : 'Document'}
          </Text>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 10 }}>
          <div>{assetVisual}</div>
        </Grid.Col>
      </Grid>
      <Group justify="flex-end" gap="xs" py="md">
        <Button variant="default" onClick={() => (closeModal ? closeModal() : navigate(-1))}>
          {' '}
          Back
        </Button>
        {deleteButton}
        <Button onClick={() => saveAsset(asset, file)} disabled={!asset.title || !asset.description}>
          <IconDeviceFloppy size={14} /> Save
        </Button>
        <ConfirmationModal
          show={confirmDeleteOpen}
          close={() => setConfirmDeleteOpen(false)}
          confirm={(cb) => deleteAsset(cb)}
          message="This action cannot be undone!"
        />
      </Group>
    </>
  );
};

export default AssetForm;
